import { Logo } from "@workspace/ui/components/logo";

import { CtaButton } from "~/components/common/cta/button";
import { appConfig } from "~/config/app";

interface CtaBannerProps {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  cta?: string;
  children?: React.ReactNode;
}

export const CtaBanner = (props: CtaBannerProps) => {
  const icon = props.icon ?? (
    <Logo logoClassName="size-12 text-primary-foreground" />
  );
  const title = props.title ?? appConfig.title;
  const description =
    props.description ??
    "Don't burn tokens on setup and start building features on day one.";
  const cta = props.cta ?? `Get ${appConfig.name}`;

  return (
    <section className="bg-primary !col-span-full grid grid-cols-subgrid justify-items-center gap-y-10 rounded-2xl py-16 sm:gap-y-12 md:gap-y-14 md:rounded-3xl md:py-24 lg:gap-y-16 lg:py-28 xl:rounded-none">
      <div className="col-start-2 flex flex-col items-center justify-center gap-8 md:gap-12">
        <div className="border-secondary/50 from-primary/80 to-secondary/30 rounded-2xl border bg-gradient-to-b p-4">
          {icon}
        </div>

        <header className="flex flex-col items-center justify-center gap-4 md:gap-6">
          <h2 className="text-primary-foreground text-center text-4xl font-medium tracking-tight text-balance sm:text-5xl md:text-6xl">
            {title}
          </h2>

          <p className="text-primary-foreground/75 max-w-3xl text-center font-medium text-pretty md:text-lg">
            {description}
          </p>
        </header>

        <CtaButton
          trigger="cta-banner"
          className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 h-auto px-8 py-4"
        >
          {cta}
        </CtaButton>
      </div>

      {props.children}
    </section>
  );
};
